import {
  Alert,
  AutoComplete,
  Avatar,
  Button,
  Checkbox,
  Drawer,
  Form,
  Input,
  Modal,
  Popconfirm,
  Radio,
  Select,
  Space,
  Spin,
  Switch,
  Tag,
} from "antd";

import { TextLoop } from "react-text-loop-next";
import React, {
  ReactElement,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import axios from "axios";
import { authenticateToken } from "../../../utils/auth";
import {
  getImgUrl,
  getParamValue,
  getUpdatedUrl,
  checkStatesAndPushToHistory,
} from "../../../utils/index";

import Loading from "../../common/Loader";
import PaginationTwo from "../../common/PaginationTwo";
import { useLocation, useParams, useHistory } from "react-router";
import Empty from "../../common/Empty";
import { responseNotification } from "../../../utils/notify";
import { debounce } from "lodash";

import {
  ApartmentOutlined,
  BarcodeOutlined,
  CheckCircleFilled,
  CheckOutlined,
  CloseOutlined,
  CopyOutlined,
  DeleteFilled,
  EditOutlined,
  IssuesCloseOutlined,
  PlusOutlined,
  QuestionCircleOutlined,
  SoundOutlined,
  SwapOutlined,
  UserOutlined,
  WarningFilled,
  ZoomInOutlined,
  ZoomOutOutlined,
  UploadOutlined,
} from "@ant-design/icons";

import ShopLayout from "../Layout";
import ShopHeader from "../Layout/topHeader";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faToggleOn } from "@fortawesome/free-solid-svg-icons";
import usePrevious from "../../../hooks/PreviousState";

export interface ProductCreateProps {
  total: number;
  categoriesOptions: any[];
  shopsOptions: any[];
  brandsOptions: any[];
  refetch: () => void;
  setType: (val) => void;
  type?: string;
}

const { Option } = Select;

const ShopProductList = (params): ReactElement => {
  const history = useHistory();
  const router = useLocation();
  const page = getParamValue(router?.search, "page");
  const [form] = Form.useForm();
  const fetchRef = useRef(null);
  // --------------------------------
  const { shopInfo } = useSelector((state) => (state as any)?.authReducer);
  const [merchantId, setMerchantId] = useState<any>(shopInfo?.merchantId);
  const shopId = shopInfo?.id;
  const route = useParams();
  // --------------------------------
  const [loading, setLoading] = useState(false);
  const [checkedList, setCheckedList] = React.useState([]);
  const [indeterminate, setIndeterminate] = React.useState(true);
  const [checkAll, setCheckAll] = React.useState(false);
  // --------------------------------

  const [status, setStatus] = useState(getParamValue(router?.search, "status"));
  const [limit, setLimit] = useState(100);
  const defaultValueOfMinimumStock = 10000000;
  const [minimumStock, setMinimumStock] = useState(
    getParamValue(router?.search, "minimumStock") || defaultValueOfMinimumStock
  );
  const [type, setType] = useState(shopInfo?.type);
  const [visible, setVisible] = useState(undefined);
  const [childrenDrawer, setChildrenDrawer] = useState(undefined);
  const [key, setKey] = useState(getParamValue(router?.search, "key"));
  const [barCode, setBarCode] = useState(
    getParamValue(router?.search, "barCode")
  );
  const [isDeleted, setIsDeleted] = useState(false);
  const [isActive, setIsActive] = useState(
    getParamValue(router?.search, "isActive")
  );
  const [activeSearch, setActiveSearch] = useState(undefined);
  const [activeClone, setActiveClone] = useState(undefined);
  const [changeCat, setChangeCat] = useState(undefined);
  const [changeStatus, setChangeStatus] = useState(undefined);
  const [assignSupplier, setAssignSupplier] = useState(undefined);
  const [assignCampaign, setAssignCampaign] = useState(undefined);
  const [onlyThisShop, setOnlyThisShop] = useState<boolean>();

  const [brandId, setBrandId] = useState<any>();

  const [campaignId, setCampaignId] = useState(
    getParamValue(router?.search, "campaignId")
  );

  const [parentCategoryId, setParentCategoryId] = useState(
    getParamValue(router.search, "parentCategoryId")
  );
  const [childCategoryId, setChildCategoryId] = useState(
    getParamValue(router.search, "childCategoryId")
  );

  const [targetCategoryId, setTargetCategoryId] = useState<any>();
  const [supplierId, setSupplierId] = useState(
    getParamValue(router.search, "supplierId")
  );
  const [selectedProductBarcode, setSelectedProductBarcode] = useState([]);
  const [selectedShopId, setSelectedShopId] = useState(
    assignSupplier ? shopId : [shopId] || []
  );
  // --------------------------------

  const [productBarcodeOptions, setProductBarcodeOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [productOptions, setProductOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [parentCatOptions, setParentCatOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [categoriesOptions, setCategoriesOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [merchantOptions, setMerchantOptions] = useState({
    loading: false,
    list: [],
  });

  const [shopsOptions, setShopsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [suppliersOptions, setSuppliersOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [shopProductData, setShopProductData] = useState({
    loading: false,
    data: null,
  });

  const [brandsOptions, setBrandsOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const [campaignOptions, setCampaignOptions] = useState<any>({
    list: [],
    loading: false,
  });

  const prevSupplierId = usePrevious(supplierId);
  const prevchildCategoryId = usePrevious(childCategoryId);
  const prevIsActive = usePrevious(isActive);
  const prevparentCategoryId = usePrevious(parentCategoryId);
  const prevBarCode = usePrevious(barCode);
  const prevKey = usePrevious(key);
  const prevMinimumStock = usePrevious(minimumStock);
  const prevCampaignId = usePrevious(campaignId);

  const reseAllFieldData = () => {
    setKey("");
    setBarCode("");
    setType("");
    setCampaignId("");
    setParentCategoryId("");
    setChildCategoryId("");
    setBrandId("");
    setSupplierId("");
    setMinimumStock(defaultValueOfMinimumStock);
    setIsActive(null);
    form.resetFields();

    history.replace(router.pathname);
    window.location.reload();
  };

  window.onbeforeunload = () => {
    saveCurrentStatesInLocalStorage();
  };
  function checkLocalStorageAndSetParams() {
    var retrievedObject = JSON.parse(
      localStorage.getItem("rememberProductsFilter")
    );
    console.log("rememberProductsFilter: ", retrievedObject);
    if (retrievedObject.barCode) setBarCode(retrievedObject.barCode);
    if (retrievedObject.parentCategoryId)
      setParentCategoryId(retrievedObject.parentCategoryId);
    if (retrievedObject.childCategoryId)
      setChildCategoryId(retrievedObject.childCategoryId);
    if (retrievedObject.key) setKey(retrievedObject.key);
    if (retrievedObject.supplierId) setSupplierId(retrievedObject.supplierId);
    if (retrievedObject.minimumStock)
      setMinimumStock(retrievedObject.minimumStock);
    if (retrievedObject.campaignId) setCampaignId(retrievedObject.campaignId);
    if (retrievedObject.isActive) setIsActive(retrievedObject.isActive);
    if (retrievedObject.page) {
      history.push(getUpdatedUrl("page", `${retrievedObject.page}`));
    }
  }

  const saveCurrentStatesInLocalStorage = () => {
    localStorage.setItem(
      "rememberProductsFilter",
      JSON.stringify({
        barCode: barCode,
        parentCategoryId: parentCategoryId,
        childCategoryId: childCategoryId,
        supplierId: supplierId,
        key: key,
        isActive: isActive,
        page: page,
        minimumStock: minimumStock,
        campaignId: campaignId,
      })
    );
  };

  // **********************************
  // Search Options
  // **********************************
  const getParentCategoryOptions = useCallback(
    async (val?: string) => {
      setParentCatOptions({ loading: true, list: [] });
      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/hub/categories/admin?id=${shopInfo?.hubId}&page=0&limit=20` +
          (val ? `&name=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setParentCatOptions({
        loading: false,
        list: res?.data?.categories?.map((category) => {
          return {
            value: category?.category?.id,
            label: category?.category?.title,
          };
        }),
      });
    },
    [type]
  );

  const getCategoriesOptions = useCallback(
    async (val?: string) => {
      setCategoriesOptions({ loading: true, list: [] });
      if (shopInfo?.hubId) {
        if (parentCategoryId) {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-parent?categoryId=${parentCategoryId}` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        } else {
          const res = await axios.get(
            `${process.env.REACT_APP_CATALOG_READER_API}/admin/category/child-category-by-hub?hubId=${shopInfo?.hubId}&page=0&limit=20` +
              (val ? `&key=${val}` : ``) +
              (type ? `&type=${type}` : ``),
            {
              headers: {
                Authorization: `Bearer ${authenticateToken()}`,
              },
            }
          );
          setCategoriesOptions({
            loading: false,
            list: res?.data?.categories?.map((category) => {
              return {
                value: category?.id,
                label: category?.title,
              };
            }),
          });
        }
      } else {
        const res = await axios.get(
          `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/categories?shopId=${shopId}&page=0&limit=20` +
            (val ? `&key=${val}` : ``) +
            (type ? `&type=${type}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        );
        setCategoriesOptions({
          loading: false,
          list: res?.data?.categories?.map((category) => {
            return {
              value: category?.category?.id,
              label: category?.category?.title,
            };
          }),
        });
      }
    },
    [type, parentCategoryId]
  );

  const getBrandsOptions = useCallback(
    async (val?: string) => {
      setBrandsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/brand/search?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (val ? `&key=${val}` : ``),

        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setBrandsOptions({
        loading: false,
        list: res?.data?.brands?.map((brand) => {
          return {
            id: brand?.id,
            name: brand?.name,
          };
        }),
      });
    },
    [type]
  );

  const getCampaignOptions = useCallback(
    async (key?: string) => {
      setCampaignOptions({ loading: true, list: null });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      axios
        .get(
          `${encodedUri}/admin/campaign/all?deleted=false&page=${page || 0}` +
            `&limit=${limit || 16}` +
            (status ? `&isActive=${status}` : ``),
          {
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
            },
          }
        )
        .then((res) => {
          setCampaignOptions({
            loading: false,
            list: res.data?.campaigns?.map((campaign) => ({
              label: campaign.name,
              value: campaign.id,
            })),
          });
        })
        .catch((err) => {
          setCampaignOptions({ loading: false, list: [] });
          console.error("campaigns: Error", err);
        });
    },
    [limit, page, status]
  );

  const getMerchantsOptions = useCallback(
    async (key?: string) => {
      setMerchantOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;
      const res = await axios.get(
        `${encodedUri}/merchant/all?page=0&limit=20` +
          (type ? `&type=${type}` : ``) +
          (key ? `&name=${key}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );

      setMerchantOptions({
        loading: false,
        list: res.data?.merchants?.map((merchant) => ({
          label: merchant.name,
          value: merchant.id,
        })),
      });
    },
    [type]
  );

  const getShopsOptions = useCallback(
    async (val?: string) => {
      setShopsOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/shop/by-merchant?page=0&limit=30` +
          (merchantId ? `&merchantId=${merchantId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setShopsOptions({
        loading: false,
        list: res?.data?.shops?.map((shop) => {
          return {
            value: shop?.id,
            label: shop?.name,
          };
        }),
      });
    },
    [type, merchantId]
  );

  const getSupplierOptions = useCallback(
    async (val?: string) => {
      setSuppliersOptions({ loading: true, list: [] });

      const res = await axios.get(
        `${process.env.REACT_APP_CATALOG_READER_API}/admin/supplier/by-shop` +
          (selectedShopId ? `?shopId=${selectedShopId}` : ``) +
          (val ? `&key=${val}` : ``) +
          (page ? `&page=${page}` : ``) +
          (limit ? `&limit=${limit}` : ``) +
          (type ? `&type=${type}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setSuppliersOptions({
        loading: false,
        list: res?.data?.suppliers?.map((supplier) => {
          return {
            value: supplier?.id,
            label: supplier?.name,
          };
        }),
      });
    },
    [type, selectedShopId]
  );

  const getProductByBarcodeOptions = useCallback(
    async (bCode) => {
      setProductBarcodeOptions({ loading: false, list: [] });

      setProductBarcodeOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&deleted=${false}` +
          (bCode ? `&barCode=${bCode}` : ``) +
          (shopId ? `&shopId=${shopId}` : ``) +
          (key ? `&key=${key}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductBarcodeOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any; barCode: any }) => {
          return {
            value: product?.barCode,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, key, isDeleted, isActive, shopId]
  );

  const getProductOptions = useCallback(
    async (val) => {
      setProductOptions({ loading: false, list: [] });

      setProductOptions({ loading: true, list: [] });
      const encodedUri = `${process.env.REACT_APP_CATALOG_READER_API}`;

      const res = await axios.get(
        `${encodedUri}/admin/product/search?page=0&limit=20&isDeleted=${false}` +
          (val ? `&key=${val}` : ``) +
          (shopId ? `&shopId=${shopId}` : ``) +
          (barCode ? `&barCode=${barCode}` : ``) +
          (type ? `&type=${type}` : ``) +
          (isActive ? `&isActive=${isActive}` : ``) +
          (status ? `&status=${status}` : ``),
        {
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
          },
        }
      );
      setProductOptions({
        loading: false,
        list: res?.data?.keys?.map((product: { name: any }) => {
          return {
            value: product?.name,
            label: product?.name,
          };
        }),
      });
    },
    [status, type, barCode, isDeleted, isActive]
  );
  // **********************************
  // Search Options
  // **********************************

  const getShopProduct = useCallback(
    (getShopId) => {
      if (getShopId) {
        try {
          setShopProductData({ loading: true, data: undefined });
          let shouldResetPage = false;
          if (localStorage.getItem("rememberProductsFilter") != null) {
            checkLocalStorageAndSetParams();
            localStorage.removeItem("rememberProductsFilter");
          } else {
            shouldResetPage = checkStatesAndPushToHistory(
              [
                prevparentCategoryId,
                prevchildCategoryId,
                prevBarCode,
                prevKey,
                prevIsActive,
                prevMinimumStock,
                prevCampaignId,
                prevSupplierId,
              ],
              [
                parentCategoryId,
                childCategoryId,
                barCode,
                key,
                isActive,
                minimumStock,
                campaignId,
                supplierId,
              ],
              [
                "parentCategoryId",
                "childCategoryId",
                "barCode",
                "key",
                "isActive",
                "minimumStock",
                "campaignId",
                "supplierId",
              ],
              history
            );
          }
          axios
            .get(
              `${
                process.env.REACT_APP_CATALOG_READER_API
              }/admin/product/v2?shopId=${getShopId}&isDeleted=${false}` +
                `&page=${shouldResetPage ? 0 : page || 0}` +
                `&limit=${limit || 16}` +
                (status ? `&status=${status}` : ``) +
                (key ? `&key=${key}` : ``) +
                (isActive ? `&isActive=${isActive}` : ``) +
                (barCode ? `&barCode=${barCode}` : ``) +
                (supplierId ? `&supplierId=${supplierId}` : ``) +
                (parentCategoryId
                  ? `&parentCategoryId=${parentCategoryId}`
                  : ``) +
                (childCategoryId ? `&childCategoryId=${childCategoryId}` : ``) +
                (brandId ? `&brandId=${brandId}` : ``) +
                (campaignId ? `&campaignId=${campaignId}` : ``) +
                (minimumStock ? `&minimumStock=${minimumStock}` : ``) +
                (type ? `&type=${type}` : ``),
              {
                headers: {
                  Authorization: `Bearer ${authenticateToken()}`,
                  "Content-Type": "application/json",
                },
              }
            )
            .then((data) => {
              if (data.status === 200) {
                setShopProductData({
                  loading: false,
                  data: data?.data,
                });
                setCheckedList(
                  data.data.products.map((product) => product?.barCode)
                );
              } else {
                setShopProductData({ loading: false, data: null });
                responseNotification(
                  data.statusText || "something went wrong",
                  "error"
                );
              }
            })
            .catch((err) => {
              setShopProductData({ loading: false, data: null });

              console.log(err);
            });
        } catch (error) {
          setShopProductData({ loading: false, data: null });

          console.log(error, "error");
        }
      }
    },

    [
      page,
      limit,
      status,
      key,
      isActive,
      barCode,
      supplierId,
      parentCategoryId,
      childCategoryId,
      brandId,
      campaignId,
      minimumStock,
      type,
    ]
  );

  //
  const onSubmit = async (data: any) => {
    setLoading(true);

    if (assignSupplier) {
      const readyData = data && {
        barCodes: selectedProductBarcode,
        shopId: shopId,
        supplierId: supplierId,
      };

      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/supplier-update`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification(
              "Supplier Successfully in Selected Shop(s)",
              "success"
            );
            onClose();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else if (assignCampaign) {
      const readyData = data && {
        campaignId: campaignId,
        barCodeShopIds: selectedProductBarcode?.map((item) => ({
          barCode: item,
          shopId: onlyThisShop ? shopId : null,
        })),
      };

      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/campaign/add-products`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification(
              "Product assigned successfully done in campaign",
              "success"
            );
            onClose();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else if (changeCat) {
      const readyData = data && {
        barCodes: selectedProductBarcode,
        shopIds: selectedShopId || shopId,
        targetCategoryId: targetCategoryId,
      };

      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/category-update`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(readyData),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          setLoading(false);

          if (res.statusCode === 200) {
            responseNotification(
              "Product Changed Category Successfully in Selected Shop(s)",
              "success"
            );
            onClose();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          setLoading(false);
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else if (activeClone) {
      const readyData = data && {
        sourceShopId: shopId,
        barCodes: selectedProductBarcode,
        shopIds: [selectedShopId || shopId],
        supplierId: supplierId,
      };
      if (selectedShopId === shopInfo?.id) {
        responseNotification("Can't clone product in ", "success");
      } else {
        await fetch(
          `${process.env.REACT_APP_CATALOG_WRITER_API}/product/add-from-product`,
          {
            method: "POST",
            headers: {
              Authorization: `Bearer ${authenticateToken()}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(readyData),
          }
        )
          .then((res) => res.json())
          .then((res) => {
            setLoading(false);

            if (res.statusCode === 200) {
              responseNotification(
                "Product Cloned Successfully in Selected Shop(s)",
                "success"
              );
              info({
                alreadyExists: res?.alreadyExists,
                newAdded: res?.newAdded,
                list: res?.alreadyExistsProductName,
              });
              onClose();
            } else if (res.status === 500) {
              responseNotification("Internal server error", "error");
            } else {
              responseNotification(res.message || "something wrong", "warning");
            }
          })
          .catch((err) => {
            setLoading(false);
            responseNotification(`${"Internal server error"} ${err}`, "error");
            console.error("err", err);
          });
      }
    }
  };

  const onStatusChange = async (id, val) => {
    if (id) {
      await fetch(`${process.env.REACT_APP_CATALOG_WRITER_API}/product`, {
        method: "PUT",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: id,
          // deleted: !val,
          isActive: val,
        }),
      })
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification("Status Updated Successfully", "success");
            getShopProduct(shopId);
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };

  const onCloneInGlobalProduct = async () => {
    setLoading(true);
    await fetch(
      `${process.env.REACT_APP_CATALOG_WRITER_API}/global-product/copy-from-shop?shopId=${shopId}`,
      {
        method: "POST",
        headers: {
          Authorization: `Bearer ${authenticateToken()}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          shopId: shopId,
          targetType: type,
        }),
      }
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200) {
          responseNotification("Operation Successfully Done", "success");
          setLoading(false);
          getShopProduct(shopId);
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const onMultipleStatusChange = async () => {
    if (changeStatus === "DELETEANDACTIVE") {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/multiple-inactive-but-active-in-other-shops`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            barCodes: selectedProductBarcode,
            shopId: shopId,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Selected Item(s) Status Updated Successfully",
              "success"
            );
            getShopProduct(shopId);
            setVisible(undefined);
            setChildrenDrawer(undefined);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    } else {
      await fetch(
        `${process.env.REACT_APP_CATALOG_WRITER_API}/product/multiple-active-inactive`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${authenticateToken()}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            barCodes: selectedProductBarcode,
            shopIds: selectedShopId || [shopId],
            isActive: changeStatus === "ACTIVE" ? true : false,
            deleted: changeStatus === "DELETE" ? true : false,
          }),
        }
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            responseNotification(
              "Selected Item(s) Status Updated Successfully",
              "success"
            );
            getShopProduct(shopId);
            setVisible(undefined);
            setChildrenDrawer(undefined);
            form.resetFields();
          } else if (res.status === 500) {
            responseNotification("Internal server error", "error");
          } else {
            responseNotification(res.message || "something wrong", "warning");
          }
        })
        .catch((err) => {
          responseNotification(`${"Internal server error"} ${err}`, "error");
          console.error("err", err);
        });
    }
  };
  //

  const onChange = (e) => {
    setSelectedProductBarcode((prevVal: any) => {
      const newVal = e;
      let newArr = Array.from(prevVal);
      const found = prevVal.find((item) => item === newVal);
      if (!found) {
        newArr.push(newVal);
      } else {
        newArr = newArr.filter((item) => item !== newVal);
      }
      return newArr;
    });

    setIndeterminate(
      !!checkedList.length &&
        checkedList.length <= selectedProductBarcode.length
    );
    setCheckAll(checkedList.length === selectedProductBarcode.length);
  };

  const onCheckAllChange = (e) => {
    setSelectedProductBarcode(e.target.checked ? checkedList : []);
    setIndeterminate(false);
    setCheckAll(e.target.checked);
  };

  const handleSearch = React.useMemo(() => {
    const loadOptions = (value: string, field: string) => {
      fetchRef.current += 1;
      const fetchId = fetchRef.current;

      if (fetchId !== fetchRef.current) {
        return;
      }

      if (value) {
        if (field === "product") getProductOptions(value);
        else if (field === "productByBarcode")
          getProductByBarcodeOptions(value);
        else if (field === "parentCategory") getParentCategoryOptions(value);
        else if (field === "category") getCategoriesOptions(value);
        else if (field === "brand") getBrandsOptions(value);
        else if (field === "campaign") getCampaignOptions(value);
        else if (field === "merchant") getMerchantsOptions(value);
        else if (field === "shop") getShopsOptions(value);
        else if (field === "supplier") getSupplierOptions(value);
      }
    };

    return debounce(loadOptions, 800);
  }, [
    getParentCategoryOptions,
    getCategoriesOptions,
    getBrandsOptions,
    getCampaignOptions,
    getProductOptions,
    getProductByBarcodeOptions,
    getMerchantsOptions,
    getShopsOptions,
    getSupplierOptions,
  ]);

  useEffect(() => {
    getShopProduct(shopId);
  }, [getShopProduct, shopId]);

  useEffect(() => {
    if (supplierId) {
      getShopProduct(shopId);
    }
  }, [getShopProduct, supplierId]);

  useEffect(() => {
    if (type) {
      getMerchantsOptions();
    }
  }, [getMerchantsOptions, type]);

  useEffect(() => {
    if (activeSearch || changeCat) {
      getParentCategoryOptions();
      getCategoriesOptions();
      getBrandsOptions();
      getSupplierOptions();
    }
  }, [
    getBrandsOptions,
    getParentCategoryOptions,
    getCategoriesOptions,
    getSupplierOptions,
    activeSearch,
    changeCat,
  ]);

  useEffect(() => {
    if (changeStatus) {
      form.resetFields();
    }
  }, [changeStatus]);

  useEffect(() => {
    if (activeClone) {
      form.resetFields();
      getMerchantsOptions();
    }
  }, [activeClone, getMerchantsOptions]);

  useEffect(() => {
    getShopsOptions();
    getCampaignOptions("");
  }, [getShopsOptions, getCampaignOptions]);

  useEffect(() => {
    if (selectedShopId) {
      getSupplierOptions();
    }
  }, [getSupplierOptions, selectedShopId]);

  useEffect(() => {
    if (parentCategoryId) {
      setChildCategoryId(undefined);
      form.resetFields(["sub_category_search"]);
    }
  }, [parentCategoryId]);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(undefined);
    setActiveClone(undefined);
    setChangeCat(undefined);
    setChangeStatus(undefined);
    setAssignSupplier(undefined);
    setAssignCampaign(undefined);
    getShopProduct(shopId);
    form.resetFields();
  };

  const onChildrenDrawerClose = () => {
    setChildrenDrawer(undefined);
    setChangeStatus(undefined);
    setChangeStatus(undefined);
  };

  function info(alreadyExistsData) {
    Modal.info({
      title: `Successfully added ${alreadyExistsData?.newAdded} item(s) and already exists ${alreadyExistsData?.alreadyExists} item(s)`,
      content: (
        <ul>
          {alreadyExistsData?.list?.map((alreadyExistsProductName, i) => (
            <>
              <small>
                {i + 1}. {alreadyExistsProductName}
              </small>
              <br />
            </>
          ))}
        </ul>
      ),
      width: 600,
      onOk() {},
      okText: "GOT IT",
    });
  }

  return (
    <React.Fragment>
      <ShopLayout shopId={shopId}>
        <>
          <section className="product-lists">
            <div className="product-list-item-area white-bg">
              <ShopHeader
                leftarea={"Product List"}
                rightarea={
                  <div className="d-flex">
                    {activeSearch ? (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(false);
                          reseAllFieldData();
                        }}
                        danger
                      >
                        <ZoomOutOutlined />
                      </Button>
                    ) : (
                      <Button
                        type="dashed"
                        onClick={() => {
                          setActiveSearch(true);
                        }}
                      >
                        <ZoomInOutlined />
                      </Button>
                    )}

                    <Button
                      type="primary"
                      onClick={() => {
                        showDrawer();
                        // setActiveClone(true);
                      }}
                      disabled={!selectedProductBarcode.length}
                      title="Clone Product"
                      className="mx-2"
                    >
                      <SwapOutlined /> Action
                    </Button>

                    <Popconfirm
                      title={
                        "Do you Confirm to reserve all products in this shop for Global Products?"
                      }
                      onConfirm={() => onCloneInGlobalProduct()}
                      okText="Clone"
                      okButtonProps={{ loading: loading }}
                    >
                      <Button type="dashed" className="mr-2">
                        Store in Global
                      </Button>
                    </Popconfirm>
                    <Link to={`/shops/${shopId}/bulkupload`}>
                      <Button type="dashed" className="mr-2">
                        <UploadOutlined /> Bulk Upload
                      </Button>
                    </Link>
                    <Link to={`/shops/${shopId}/bulkupdate`}>
                      <Button type="dashed" danger className="mr-2">
                        <UploadOutlined /> Bulk Update
                      </Button>
                    </Link>

                    {type !== "JC_MART" && (
                      <Button
                        onClick={() => {
                          history.push(`/shops/${shopId}/products/add`);
                        }}
                        danger
                        type="primary"
                        icon={<PlusOutlined />}
                        title="Add Product"
                        disabled={
                          shopInfo?.type === "JC_MART"
                            ? !shopInfo?.hubId
                            : false
                        }
                      >
                        Add New
                      </Button>
                    )}
                  </div>
                }
              />

              {activeSearch && (
                <div className="search_area mb-0">
                  <Form form={form} className="search_form">
                    <Form.Item name="barcode_search" initialValue={barCode}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "productByBarcode")}
                        onSelect={(val) => setBarCode(val)}
                        options={productBarcodeOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productBarcodeOptions?.loading ? (
                            <Spin size="small" />
                          ) : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by BarCode"
                          onSearch={(val) => {
                            setBarCode(val);
                          }}
                          enterButton
                          loading={productBarcodeOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>
                    <Form.Item name="product_search" initialValue={key}>
                      <AutoComplete
                        onSearch={(e) => handleSearch(e, "product")}
                        onSelect={(val) => setKey(val.toString())}
                        options={productOptions?.list}
                        defaultActiveFirstOption={false}
                        notFoundContent={
                          productOptions?.loading ? <Spin size="small" /> : null
                        }
                      >
                        <Input.Search
                          size="large"
                          placeholder="Search by Name"
                          onSearch={(val) => {
                            setKey(val);
                          }}
                          enterButton
                          loading={productOptions.loading}
                          pattern={`[0-9]`}
                          maxLength={11}
                        />
                      </AutoComplete>
                    </Form.Item>
                    <Form.Item name="supplier_search">
                      <Select
                        allowClear
                        autoClearSearchValue
                        showSearch
                        placeholder="Filter by Supplier"
                        optionFilterProp="children"
                        onChange={(val) => setSupplierId(val)}
                        onSearch={(e) => handleSearch(e, "supplier")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {suppliersOptions?.list?.map((supplier) => (
                          <Option value={supplier.value}>
                            {supplier.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="parentCategory_search">
                      <Select
                        allowClear
                        showSearch
                        placeholder="Filter by Category"
                        optionFilterProp="children"
                        onChange={(val) => setParentCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "parentCategory")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {parentCatOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item
                      name="sub_category_search"
                      initialValue={childCategoryId}
                    >
                      <Select
                        allowClear
                        showSearch
                        placeholder="Sub Category"
                        optionFilterProp="children"
                        onChange={(val) => setChildCategoryId(val)}
                        onSearch={(e) => handleSearch(e, "category")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {categoriesOptions?.list?.map((category) => (
                          <Option value={category.value}>
                            {category.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                    <Form.Item name="campaign_search">
                      <Select
                        allowClear
                        showSearch
                        placeholder="Campaign"
                        optionFilterProp="children"
                        onChange={(val) => setCampaignId(val)}
                        onSearch={(e) => handleSearch(e, "campaign")}
                        filterOption={(input, option) =>
                          option.children
                            .toString()
                            .toLowerCase()
                            .indexOf(input.toLowerCase()) >= 0
                        }
                      >
                        {campaignOptions?.list?.map((campaign) => (
                          <Option value={campaign.value}>
                            {campaign.label}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="status_search"
                      initialValue={
                        isActive == "true"
                          ? "ACTIVE"
                          : isActive == "false"
                          ? "INACTIVE"
                          : "ALL"
                      }
                    >
                      <Select
                        showSearch
                        placeholder="Status"
                        onChange={(val) => setIsActive(val as string)}
                      >
                        <Select.Option value="">ALL</Select.Option>
                        <Select.Option value={"true"}>ACTIVE</Select.Option>
                        <Select.Option value={"false"}>INACTIVE</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item
                      name="stock_search"
                      initialValue={
                        minimumStock == defaultValueOfMinimumStock
                          ? "ALL"
                          : "OUT OF STOCK"
                      }
                    >
                      <Select
                        showSearch
                        placeholder="Minimum Stock"
                        onChange={(val) => setMinimumStock(val)}
                      >
                        <Select.Option value={defaultValueOfMinimumStock}>
                          ALL{" "}
                        </Select.Option>
                        <Select.Option value="0">OUT OF STOCK</Select.Option>
                      </Select>
                    </Form.Item>

                    <Form.Item name="limit_search" initialValue={limit}>
                      <Select
                        showSearch
                        placeholder="Limit"
                        onChange={(val) => setLimit(val)}
                      >
                        <Option value="100">100</Option>
                        <Option value="500">500</Option>
                        <Option value="1000">1000</Option>
                      </Select>
                    </Form.Item>
                  </Form>
                  <div className="search_btn">
                    <Button
                      type="primary"
                      size="large"
                      danger
                      onClick={reseAllFieldData}
                    >
                      Reset
                    </Button>
                  </div>
                </div>
              )}

              <div className="">
                <div className="product-list-items-inner-content">
                  <div className="single-product-wrapper">
                    <div className="single-product-heading major">
                      <Checkbox
                        indeterminate={indeterminate}
                        onChange={onCheckAllChange}
                        checked={
                          checkAll ||
                          selectedProductBarcode?.length === checkedList?.length
                        }
                        className="mr-3"
                      >
                        Check all
                      </Checkbox>
                    </div>
                    <div className="single-product-heading major">
                      <span>Stock & Price</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Status</span>
                    </div>
                    <div className="single-product-heading">
                      <span>Action</span>
                    </div>
                  </div>
                </div>
              </div>

              {shopProductData.loading ? (
                <Loading />
              ) : (
                <div className="product-table">
                  <div className="product-table-area">
                    {shopProductData?.data?.products?.length ? (
                      shopProductData?.data?.products?.map(
                        (product: any, index: number) => (
                          <React.Fragment key={index}>
                            <Link
                              to={`/shops/${
                                (route as any)?.shopId as string
                              }/products/${product?.slug}/details`}
                              onClick={saveCurrentStatesInLocalStorage}
                            >
                              <div className="single-product-wrapper">
                                <div className="single-product major">
                                  <Checkbox
                                    onClick={(e) => {
                                      e.preventDefault();
                                      onChange(product?.barCode);
                                    }}
                                    checked={selectedProductBarcode?.find(
                                      (item) => product?.barCode === item
                                    )}
                                    className="mr-3"
                                    value={product?.barCode}
                                    disabled={
                                      shopInfo?.deleted || product?.hub?.deleted
                                    }
                                  />
                                  <Avatar
                                    shape="square"
                                    size={{
                                      xs: 24,
                                      sm: 32,
                                      md: 40,
                                      lg: 50,
                                      xl: 50,
                                      xxl: 50,
                                    }}
                                    style={{
                                      minWidth: 50,
                                    }}
                                    src={getImgUrl(product?.productImage)}
                                    className="mr-2"
                                  />
                                  <span className="name">
                                    {product?.name.substring(50, 0)}
                                  </span>
                                </div>

                                <div className="single-product major">
                                  <div className="">
                                    {product?.variations?.length
                                      ? product?.variations?.map(
                                          (variant, index) => (
                                            <React.Fragment key={index}>
                                              <div className="d-flex justify-content-start mb-1">
                                                {variant?.barCode ? (
                                                  <Tag className="d-flex align-items-center">
                                                    <BarcodeOutlined className="mr-1" />{" "}
                                                    {variant?.barCode}
                                                  </Tag>
                                                ) : product?.barCode ? (
                                                  <Tag className="d-flex align-items-center">
                                                    <BarcodeOutlined className="mr-1" />{" "}
                                                    {product?.barCode}
                                                  </Tag>
                                                ) : undefined}
                                                <Tag
                                                  color={
                                                    variant?.stock < 10
                                                      ? `red`
                                                      : `green`
                                                  }
                                                >
                                                  {variant?.variationName?.toUpperCase()}
                                                  : <b>{variant?.stock || 0}</b>
                                                </Tag>
                                              </div>
                                              <div className="d-flex justify-content-start mb-1">
                                                <Tag>
                                                  MRP{" "}
                                                  {variant?.price?.currencyCode}
                                                  {variant?.price
                                                    ?.discountedPrice ||
                                                    variant?.price?.mrp}
                                                  {variant?.price
                                                    ?.discountedPrice &&
                                                    variant?.price
                                                      ?.discountedPrice !==
                                                      variant?.price?.mrp && (
                                                      <span className="text-danger">
                                                        {" "}
                                                        <del>
                                                          {variant?.price
                                                            ?.currencyCode ||
                                                            "Tk"}
                                                          {variant?.price?.mrp}
                                                        </del>
                                                      </span>
                                                    )}
                                                </Tag>
                                                <Tag>
                                                  TP {variant?.price?.tp}{" "}
                                                  {variant?.price?.currencyCode}
                                                </Tag>
                                              </div>
                                            </React.Fragment>
                                          )
                                        )
                                      : undefined}
                                  </div>
                                </div>

                                <div className="single-product">
                                  <Switch
                                    checkedChildren={<CheckOutlined />}
                                    unCheckedChildren={<CloseOutlined />}
                                    defaultChecked={product?.isActive}
                                    onChange={(val, e) => {
                                      e.preventDefault();
                                      onStatusChange(product?.id, val);
                                    }}
                                    disabled={
                                      shopInfo?.deleted || product?.hub?.deleted
                                    }
                                  />
                                </div>
                                {console.log("shopInfo", shopInfo?.deleted)}

                                <div className="single-product">
                                  <Link
                                    onClick={saveCurrentStatesInLocalStorage}
                                    to={`/shops/${
                                      (route as any)?.shopId as string
                                    }/products/${product?.slug}/edit`}
                                    className="btn btn-sm border"
                                  >
                                    <EditOutlined />
                                  </Link>
                                </div>
                              </div>
                            </Link>
                          </React.Fragment>
                        )
                      )
                    ) : (
                      <Empty data="Products" />
                    )}
                  </div>
                </div>
              )}
              <PaginationTwo
                {...shopProductData?.data}
                limit={limit}
                page={shopProductData?.data?.currentPageNumber || 0}
              />
            </div>
          </section>
        </>
      </ShopLayout>

      <Drawer
        title={activeClone ? "Clone Product" : "Change Option"}
        placement="right"
        onClose={onClose}
        visible={visible}
        width={550}
      >
        <Radio.Group defaultValue="" className="mb-5">
          <Radio.Button
            value="clone_product"
            onChange={() => {
              setActiveClone(true);
              setChangeCat(undefined);
              setAssignSupplier(undefined);
              setAssignCampaign(undefined);
              setChangeStatus(undefined);
              form.resetFields();
            }}
          >
            <CopyOutlined /> Clone
          </Radio.Button>
          <Radio.Button
            value="change_category"
            onChange={() => {
              setChangeCat(true);
              setActiveClone(undefined);
              setAssignSupplier(undefined);
              setAssignCampaign(undefined);
              setChangeStatus(undefined);
              form.resetFields();
            }}
          >
            <ApartmentOutlined /> Category
          </Radio.Button>
          <Radio.Button
            value="assign_supplier"
            onChange={() => {
              setAssignSupplier(true);
              setAssignCampaign(undefined);
              setChangeCat(undefined);
              setActiveClone(undefined);
              setChangeStatus(undefined);
              form.resetFields();
            }}
          >
            <UserOutlined /> Supplier
          </Radio.Button>
          <Radio.Button
            value="change_status"
            onChange={() => {
              setChangeStatus(true);
              setChangeCat(undefined);
              setActiveClone(undefined);
              setAssignSupplier(undefined);
              setAssignCampaign(undefined);
              form.resetFields();
            }}
          >
            <QuestionCircleOutlined /> Status
          </Radio.Button>
          <Radio.Button
            value="assign_campaign"
            onChange={() => {
              setChangeStatus(undefined);
              setChangeCat(undefined);
              setActiveClone(undefined);
              setAssignSupplier(undefined);
              setAssignCampaign(true);
              form.resetFields();
            }}
          >
            <SoundOutlined /> Campaign
          </Radio.Button>
        </Radio.Group>

        <Form
          name="control-hooks"
          labelCol={{ span: 24 }}
          wrapperCol={{ span: 24 }}
          className="ant-form ant-form-vertical"
          onFinish={onSubmit}
          form={form} // like ref
          layout="vertical"
          autoComplete="off"
          initialValues={{
            shopId: !activeClone ? [shopId] : undefined,
          }}
        >
          <Form.Item label="Product Barcodes">
            <Input.TextArea value={selectedProductBarcode} disabled rows={8} />
          </Form.Item>

          {activeClone && (
            <Alert
              message="Where do you want to CLONE
                the selected items?"
              type="warning"
              banner
              closable
              className="mb-4"
            />
          )}
          {changeStatus && (
            <Alert
              message="Where do you want to make the STATUS change of selected Items"
              type="error"
              banner
              closable
              className="mb-4"
            />
          )}
          {changeCat && (
            <Alert
              message="Where do you want to make the CATEGORY changes"
              type="warning"
              banner
              closable
              className="mb-4"
            />
          )}
          {assignSupplier && (
            <Alert
              message="Please Select A Supplier To Change/Assign Supplier For Selected Items"
              type="info"
              banner
              closable
              className="mb-4"
            />
          )}
          {assignCampaign && (
            <Alert
              message="Please Select A Campaign to Assign Selected Items"
              type="info"
              banner
              closable
              className="mb-4"
            />
          )}

          {!assignSupplier && activeClone && (
            <>
              <Form.Item label="Select Merchant" initialValue={merchantId}>
                <Select
                  allowClear
                  showSearch
                  placeholder="Select Merchant"
                  optionFilterProp="children"
                  onChange={(val) => setMerchantId(val)}
                  onSearch={(e) => handleSearch(e, "merchant")}
                  filterOption={(input, option) =>
                    option.children
                      .toString()
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                >
                  {merchantOptions.list.map((merchant) => (
                    <Option value={merchant.value} key={merchant.value}>
                      {merchant.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
              <Form.Item
                style={{ minWidth: "100%" }}
                label="Select Shop"
                name="shopId"
                rules={[
                  {
                    required: true,
                    message: "Shop is required!",
                  },
                ]}
              >
                <Select
                  allowClear
                  autoClearSearchValue
                  mode={changeStatus || changeCat ? "tags" : undefined}
                  onSearch={() => {
                    getShopsOptions();
                  }}
                  onChange={(val) => {
                    setSelectedShopId(val);
                  }}
                  options={shopsOptions?.list}
                  maxTagTextLength={20}
                  disabled={
                    shopsOptions?.list?.find((shop) => shop?.id) ===
                    shopInfo?.id
                      ? true
                      : false
                  }
                  placeholder="Select Shop"
                ></Select>
              </Form.Item>
              {suppliersOptions?.list?.length ? (
                <Form.Item label="Select Supplier" name="supplierId">
                  <Select
                    allowClear
                    autoClearSearchValue
                    onSearch={(e) => handleSearch(e, "supplier")}
                    onChange={(val) => setSupplierId(val)}
                    options={suppliersOptions?.list}
                    maxTagTextLength={20}
                    // disabled={!shopId || !selectedShopId}
                    placeholder="Select Supplier if Needed"
                  ></Select>
                </Form.Item>
              ) : (
                <Alert
                  message={
                    <TextLoop springConfig={{ stiffness: 220, damping: 5 }}>
                      <span>No Supplier Found</span>
                      <span>In this selected Shop!</span>
                    </TextLoop>
                  }
                  type="error"
                  className="mb-4"
                />
              )}
            </>
          )}

          {assignSupplier && (
            <Form.Item label="Select Supplier" name="supplierId">
              <Select
                allowClear
                // showSearch
                autoClearSearchValue
                onSearch={(e) => handleSearch(e, "supplier")}
                onChange={(val) => setSupplierId(val)}
                options={suppliersOptions?.list}
                maxTagTextLength={20}
                placeholder="Select Supplier if Needed"
              ></Select>
            </Form.Item>
          )}

          {assignCampaign && (
            <>
              <div className="my-3">
                <h4>Where you Want to Update?</h4>
                <Switch
                  checkedChildren="This Shop"
                  unCheckedChildren="Any Shop"
                  className="ml-2"
                  onChange={(val) => setOnlyThisShop(val)}
                />
              </div>
              <Form.Item label="Select Campaign" name="campaignId">
                <Select
                  allowClear
                  // showSearch
                  autoClearSearchValue
                  onSearch={(e) => handleSearch(e, "campaign")}
                  onChange={(val) => setCampaignId(val)}
                  options={campaignOptions?.list}
                  maxTagTextLength={20}
                  placeholder="Select Campaign"
                ></Select>
              </Form.Item>
            </>
          )}

          {changeCat && (
            <>
              <Form.Item
                style={{ minWidth: "100%" }}
                label="Select Category"
                name="targetCategoryId"
              >
                <Select
                  allowClear
                  showSearch
                  autoClearSearchValue
                  onSearch={() => {
                    getCategoriesOptions();
                  }}
                  onChange={(val) => {
                    setTargetCategoryId(val);
                  }}
                  options={categoriesOptions?.list}
                  maxTagTextLength={20}
                  placeholder="Select Category"
                ></Select>
              </Form.Item>
            </>
          )}

          {changeStatus ? (
            <>
              <Button
                type="dashed"
                danger
                size="large"
                onClick={() => setChildrenDrawer(true)}
              >
                <FontAwesomeIcon icon={faToggleOn} className="mr-2" />
                Change Status
              </Button>
            </>
          ) : (
            <Button
              type="primary"
              danger
              title="Clone Selected Items"
              htmlType="submit"
              size="large"
              disabled={
                (!changeCat &&
                  !activeClone &&
                  !assignSupplier &&
                  !assignCampaign) ||
                loading
              }
              loading={(loading ? "loading" : undefined) as any}
            >
              Submit
            </Button>
          )}
        </Form>

        <Drawer
          title="Change Status"
          width={365}
          closable={false}
          onClose={onChildrenDrawerClose}
          visible={childrenDrawer}
        >
          <Radio.Group>
            <Space direction="vertical">
              <Radio
                value="1"
                onChange={() => setChangeStatus("ACTIVE")}
                disabled={shopInfo?.deleted}
              >
                <CheckCircleFilled className="text-success" /> ACTIVE SELECTED
                ITEMS
              </Radio>
              <Radio value="2" onChange={() => setChangeStatus("INACTIVE")}>
                <WarningFilled className="text-warning" /> INACTIVE SELECTED
                ITEMS
              </Radio>
              <Radio
                value="3"
                onChange={() => setChangeStatus("DELETEANDACTIVE")}
                disabled={shopInfo?.deleted}
              >
                <IssuesCloseOutlined className="text-danger mr-1" />
                INACTIVE &amp; ACTIVE IN ANOTHER SHOP
              </Radio>
              <Radio value="4" onChange={() => setChangeStatus("DELETE")}>
                <DeleteFilled className="text-danger" /> DELETE SELECTED ITEMS
              </Radio>
            </Space>
          </Radio.Group>
          <Button
            type="primary"
            danger
            title="Clone Selected Items"
            disabled={!checkedList || !changeStatus}
            htmlType="submit"
            size="large"
            className="mt-4"
            onClick={() => onMultipleStatusChange()}
          >
            Change Status
          </Button>
        </Drawer>
      </Drawer>
    </React.Fragment>
  );
};

export default ShopProductList;
